<template>
  <div id="standby" :style='{"display": (isStandby? "block" : "none" )}'>
    <div id="standbybg"></div>
    <div id="standbytext">
        <p>{{headline}}</p>
        <p>{{subline}}</p>
    </div>
  </div>           
</template>




<script>
export default {
    name: "standby",
    props: ['headline', 'subline'],
    data() {
        return {
            isStandby: false,
            timeoutID: "",
        }
    },
    methods: {
        startTimer() {
            this.timeoutID = window.setTimeout(() => {
                this.isStandby = true;
                this.$router.replace({path: "/" + this.$route.params.topic})
            }, window.appStandbyTime);
        },
        resetTimer() {
            window.clearTimeout(this.timeoutID);
            this.isStandby = false;
            this.startTimer();
        },
     },
    created() {
        window.addEventListener("mousemove", (e) => {if(this.isStandby) e.preventDefault(); this.resetTimer()});
        window.addEventListener("mousedown", (e) => {if(this.isStandby) e.preventDefault(); this.resetTimer()});
        window.addEventListener("keypress", (e) => {if(this.isStandby) e.preventDefault(); this.resetTimer()});
        window.addEventListener("mousewheel", (e) => {if(this.isStandby) e.preventDefault(); this.resetTimer()});
        window.addEventListener("touchmove", (e) => {if(this.isStandby) e.preventDefault(); this.resetTimer()});
        this.startTimer();
  },
};
</script>



<style>

</style>



// WEBPACK FOOTER //
// src/components/Standby.vue